/* eslint-disable @typescript-eslint/no-var-requires */
export const { default: PVIcon } = require('./pv.svg');
export const { default: UVIcon } = require('./uv.svg');
export const { default: VVICon } = require('./vv.svg');
export const { default: processingIcon } = require('./processing.svg');
export const { default: onGoingIcon } = require('./onGoing.svg');
export const { default: returnIcon } = require('./returned.svg');
